import { IconProps } from "@/models";

export function BankSlipMiniIcon({ size = 20, color = "#3D485C" }: IconProps) {
  return ( 
    <svg 
        width={size} 
        height={size}
        viewBox="0 0 18 14" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="0.666016" y="0.50293" width="2.63158" height="13.3333" fill={color} />
        <rect x="14.7012" y="0.50293" width="2.63158" height="13.3333" fill={color} />
        <rect x="7.68359" y="0.50293" width="0.877193" height="13.3333" fill={color} />
        <rect x="4.17578" y="0.50293" width="1.75439" height="13.3333" fill={color} />
        <rect x="9.4375" y="0.50293" width="3.50877" height="13.3333" fill={color} />
    </svg>
  )
}